
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AuthorizedUser } from '@/types/users';

@Component
export default class UserInfoSummary extends Vue {
  @Prop({ required: true }) user!: AuthorizedUser;
}
